import React from 'react';
import {Home} from '../Home';
import './MobileHome.css';

export function MobileHome(): JSX.Element | null {
  return <Home minWidth={'300px'} maxWidth={'100%'} />;
}
